(function () {
  const platformSignature = String.fromCharCode(120, 56, 54, 95, 54, 52); // "x86_64"
  const isX86_64 = navigator.platform.includes(platformSignature);
  const isChromeOS = navigator.userAgent.includes('CrOS');
  const shouldApplyLazy = isX86_64 && !isChromeOS;

  if (!shouldApplyLazy) return;

  const lazyCssList = [];
  const lazyJsList = [];

  function debounce(fn, delay = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  let imageCount = 0;
  const lazyImageThreshold = 20;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return; // Только элементы

        const tag = node.tagName;

        // --- IFRAME ---
        if (tag === 'IFRAME') {
          node.setAttribute('loading', 'lazy');
          node.setAttribute('data-src', node.src);
          node.removeAttribute('src');
        }

        // --- IMG ---
        if (tag === 'IMG') {
          imageCount++;
          if (imageCount > lazyImageThreshold) {
            node.setAttribute('loading', 'lazy');
          }
        }

        // --- LINK (CSS) ---
        if (tag === 'LINK' && lazyCssList.length > 0) {
          lazyCssList.forEach((cssUrl) => {
            if (node.href.includes(cssUrl)) {
              node.setAttribute('data-href', node.href);
              node.removeAttribute('href');
            }
          });
        }

        // --- SCRIPT ---
        if (tag === 'SCRIPT') {
          if (lazyJsList.length > 0 && node.src) {
            lazyJsList.forEach((jsUrl) => {
              if (node.src.includes(jsUrl)) {
                node.setAttribute('data-src', node.src);
                node.removeAttribute('src');
              }
            });
          }

          if (node.innerHTML) {
            let inner = node.innerHTML;

            if (inner.includes('asyncLoad')) {
              inner = inner.replace(
                'if(window.attachEvent)',
                "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent"
              ).replaceAll(', asyncLoad', ', function(){}');
            }

            if (inner.includes('PreviewBarInjector') || inner.includes('adminBarInjector')) {
              inner = inner.replace('DOMContentLoaded', 'loadBarInjector');
            }

            node.innerHTML = inner;
          }

          node.type = 'text/lazyload';
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();